import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { SearchParam, IssueSetup } from 'models/setup/issue/issue';
import { CommonCode, CommonCodeGroup } from 'models/admin/CommonCode';

export const getIssueSetupList = async (condition: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/projectIssue`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<IssueSetup[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IssueSetup[];
};

export const findProjectById = async (isuId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/projectIssue/${isuId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<IssueSetup> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IssueSetup;
};

export const findIsuCrgeUser = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/getProjectIssueManagerList/${elmPrjId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<IssueSetup[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IssueSetup[];
};

export const findExcpCrgeUser = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/getProjectIssueExcpManagerList/${elmPrjId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<IssueSetup[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IssueSetup[];
};

export const findEqclIdList = async (eqclId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/getCmnGrCdByEqclId/${eqclId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<IssueSetup> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IssueSetup;
};

export const saveIssue = async (createData: IssueSetup | undefined) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/projectIssue`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: createData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const getProjectIssueCnt = async (condition: IssueSetup) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/projectIssueCnt`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<IssueSetup> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IssueSetup;
};
